import React from 'react';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { openServiceDeskChatOrEmail } from '../utils/serviceDesk';
import type { TFunction } from 'i18next';

export const tierList = (t: TFunction<'containerInterface'>) => [
  { pricing: '$0/month', minUnits: 0, maxUnits: 1000, name: t('freeTier') },
  {
    pricing: '$3,000/month',
    minUnits: 1001,
    maxUnits: 4000,
    name: t('forSmallTeams'),
  },
  {
    pricing: '$6,000/month',
    minUnits: 4001,
    maxUnits: 8000,
    name: t('forMediumTeams'),
  },
  {
    pricing: '$12,000/month',
    minUnits: 8001,
    maxUnits: 16000,
    name: t('forLargeTeams'),
  },
  {
    pricing: (
      <button
        className="bg-br-secondary text-br-primary mt-4 inline-flex items-center rounded-md p-4 text-xl leading-tight font-medium"
        onClick={() => {
          openServiceDeskChatOrEmail();
        }}
      >
        {t('speakWithSales')}{' '}
        <ChevronRightIcon className="h-8 w-8 flex-shrink-0" />
      </button>
    ),
    minUnits: 16001,
    maxUnits: Infinity,
    name: t('forXLargeTeams'),
  },
];
